import classNames from 'classnames';
import MapDirection from 'components/MapDirection';
import usStates from 'constants/usStates';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';

import ContactNLabelButtons from '../../ContactNLabelButtons';
import { useCommonActionButtonsForAppointments } from '../../helpers';
import { INotaryAppointmentType } from '../../types';

const TodayAppointment: React.FC<INotaryAppointmentType> = ({
  appointment,
  isMobile,
  transactionTypesData,
  refetchAppointmentData,
}) => {
  const userId = useCurrentLoggedInUser().id;
  // const type = appointmentTypeOptionsArray.find((sc) => sc.value === appointment?.type)?.label || '';

  const {
    contactClick,
    shippingLabelClick,
    generateShippingLabelLoading,
    Modal,
    AppointmentActionButtons,
    appointmentCardClick,
  } = useCommonActionButtonsForAppointments({ appointment, refetch: refetchAppointmentData, transactionTypesData });

  const unreadMessageCount = appointment.chatRoom?.unreadMessagesCount;

  const appointmentDateTime = moment(appointment.date);
  const appointmentDuration = appointment.duration;
  const appointmentTime = appointmentDateTime.format(`h:mm A`);
  const appointmentDateTimeAsMilliseconds = appointmentDateTime.valueOf();
  const [minuteDifference, setMinuteDifferent] = useState(
    Math.ceil((appointmentDateTimeAsMilliseconds - Date.now()) / 60000),
  );
  const appointmentStatus = useMemo(() => {
    const current = Date.now();
    if (
      appointmentDateTime
        .clone()
        .add((appointmentDuration || 0) / 3600, 'h')
        .isBefore(current)
    ) {
      return ['PAST'];
    }
    if (minuteDifference)
      if (minuteDifference < 60 && minuteDifference > 0) {
        return [
          'In',
          <div className='highlight'>
            {minuteDifference}
            <span className='sup'>min</span>
          </div>,
          appointmentTime,
        ];
      } else if (minuteDifference < 0) {
        return ['NOW'];
      }
    const timeWithSuffix = appointmentTime.split(' ');
    return ['At', <div className='highlight'>{timeWithSuffix[0]}</div>, timeWithSuffix[1]];
  }, [appointment.date, minuteDifference]);

  useEffect(() => {
    const intervalCheckClock = setInterval(() => {
      const nowDiff = Math.ceil((appointmentDateTimeAsMilliseconds - Date.now()) / 60000);
      setMinuteDifferent(nowDiff);
    }, 1000);
    return () => {
      clearInterval(intervalCheckClock);
    };
  }, []);

  const appointmentAddress = appointment.address;
  const isAppointmentAccepted = userId === appointment.notary?.id;

  return (
    <>
      {Modal}
      <div className='today-appointment appointment-card' onClick={appointmentCardClick}>
        <div className='time'>
          {appointmentStatus.map((status, index) => {
            const className = classNames({
              'past-status': status === 'PAST',
              'now-status': status === 'NOW',
            });
            return (
              <div className={className} key={index}>
                {status}
              </div>
            );
          })}
        </div>
        <div className='appointment-map'>
          <MapDirection
            hideDirectionBox
            style={{ width: !isMobile ? '150px' : '100%', height: !isMobile ? '100%' : '150px' }}
            location={appointmentAddress}
          />
        </div>
        <div className='appointment-info'>
          <div className='appointment-info-description'>Notary Appointment</div>
          <div className='appointment-info-address'>
            {appointment.address.address1}
            {appointment.address.address2 ? ` ${appointmentAddress.address1}` : ''}
          </div>
          <div className='appointment-info-city-state'>
            {appointmentAddress.city}, {get(usStates, appointmentAddress.state)}
          </div>
          {isAppointmentAccepted && (
            <ContactNLabelButtons
              contactClick={contactClick}
              shippingLabelClick={shippingLabelClick}
              shippingLabelLoading={generateShippingLabelLoading}
              containerClassName='contact-label-button'
              unreadMessageCount={unreadMessageCount}
              appointment={appointment}
            />
          )}
        </div>
        <div className='appointment-info-action-buttons'>
          <AppointmentActionButtons />
        </div>
      </div>
    </>
  );
};

export default TodayAppointment;
